import { useMemo } from 'react'
import { useTranslate } from '@/utils/translate/translate-client'
import { getGiveawayConfig } from '../config/giveaway-data'
import { GiveawayConfig } from '../config/types'

export type {
  GiveawayTab,
  GiveawayHowToStep,
  PartnerLogo,
  GiveawayPrizeItem,
  GalleryImage,
  GiveawayShare,
  CongratsModal,
  SummaryPage,
  ReservationCompletePage,
  NoShowtimes,
  GiveawayConfig as GiveawayType,
} from '../config'

export { GiveawayTabEnum } from '../config'

interface Props {
  theatricalSlug: string
}

export const useGiveawayConfigData = ({ theatricalSlug }: Props): GiveawayConfig | null => {
  const { t } = useTranslate('tickets')

  return useMemo(() => {
    return getGiveawayConfig(theatricalSlug, t)
  }, [theatricalSlug, t])
}
